export const IMPRESSIONS = 'Impressions';

export const UPDATE_EULA = 'UpdateEula';

export const CHECK_NEEDS_VERIFICATION = 'CheckNeedsVerification';

export const GANDALF_SESSION = 'GandalfSession';

export const UPDATE_USER_MERGE_CONSENTED = 'UpdateUserMergeConsented';

export const CHECK_USER_MERGE_CONSENT_REQUIRED =
  'CheckUserMergeConsentRequired';

export const UPDATE_CONSENT = 'UpdateConsent';

export const SET_TOKENS = 'SetTokens';

export const GLOBAL_SIGN_OUT = 'GlobalSignOut';

export const RUM_EVENTS = {
  EULA_IMPRESSION: 'EulaImpression',
  EULA_ACCEPT: 'EulaAccept',
  EULA_CANCEL: 'EulaCancel',
  EULA_ERROR: 'EulaError',
};

export const RUM_EVENT_STATUS = {
  SUCCESS: 'Success',
  REQUEST_ERROR: 'RequestError',
  FINAL_ERROR: 'FinalError',
};

export enum SimplifiedLoginRumEvent {
  PAGE_IMPRESSION = 'SimplifiedSignInImpression',
  EMAIL_SUBMITTED = 'SimplifiedSignInEmailSubmitted',
  SOCIAL_SIGN_IN_CLICKED = 'SimplifiedSignInSocialClicked',
  LOGIN_CONVERSION_SUCCESS = 'SimplifiedLoginConversionSuccess',
  LOGIN_TIME_TO_COMPLETE = 'SimplifiedLoginTimeToComplete',
}

export const LOGIN_START_TIMESTAMP_KEY = 'simplified_login_start_ts';

export enum PostAuthRumEvent {
  // "Homecoming" related flows
  CONSENT_SHOWN = 'consent_shown',
  CONSENT_REJECTED = 'consent_rejected',
  CONSENT_ACCEPTED = 'consent_accepted',
  CONSENT_AUTO_ACCEPT = 'consent_auto_accept',
  REQUIRED_EMAIL_VERIFICATION_START = 'required_email_verification_start',
  REQUIRED_EMAIL_VERIFICATION_FAILED = 'required_email_verification_failed',
  USER_SUSPENDED = 'user_suspended',
  USER_DEACTIVATED = 'user_deactivated',
  SIGN_IN_SWITCH_NEEDED_B2I = 'sign_in_switch_needed_b2i',
  SIGN_IN_SWITCH_NEEDED_B2B = 'sign_in_switch_needed_b2b',
  PROFILE_COMPLETE = 'profile_complete',
  PROFILE_SHOWN = 'profile_shown',
  COMPLETE_PROFILE_RENDERED = 'complete_profile_rendered',
  SIMPLE_PROFILE_RENDERED = 'simple_profile_rendered',
  PROFILE_MERGE_NOTIFICATION = 'profile_merge_notification',

  // Other flows
  PAGE_TIME_OUT = 'page-time-out',
}
